module.exports = __webpack_public_path__ + "static/socials_pt-cb92ccf3e8b201645f8e5d346fa8607c.png";